import React from 'react';

interface ExpandableBlockProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  className?: string;
  children: React.ReactNode;
}

const ExpandableBlock: React.FC<ExpandableBlockProps> = ({ title, expanded, onToggle, className = '', children }) => (
  <div className={`expandable-panel ${className}${expanded ? ' expanded' : ''}`}>
    <div className="expandable-header" onClick={onToggle}>
      <h3>{title}</h3>
      <span>{expanded ? '−' : '+'}</span>
    </div>
    {expanded && (
      <div className="expandable-content">
        {children}
      </div>
    )}
  </div>
);

export default ExpandableBlock; 